import { getEnvVariable } from "../..//modules/environmentalList"

export const SystemAdminList = {
    'MPS': {
        "epsgeneral":
            [
                {
                    "type": "menu",
                    "title": "Notifications",
                    "icon": "notifications_active",
                    "materialicon": "notifications_active",
                    "link": "/notifications",
                    "key": "Notifications",
                    "style": {
                        'color': '#00bfa5'
                    }
                },
                {
                    "type": "menu",
                    "title": "My Dashboards",
                    "icon": "fa fa-cogs",
                    "materialicon": "dashboard",
                    "link": "/userdashboardflows",
                    "key": "userdashboardflows",
                    "style": {
                        'color': '#00a152'
                    }
                },
                // {
                //     "type": "menu",
                //     "title": "Statistics",
                //     "icon": "poll",
                //     "materialicon": "poll",
                //     "link": "/systemstatistics",
                //     "key": "Statistics",
                //     "style": {
                //         'color': '#A020F0'
                //     }
                // },


            ],
        "myportallist":
            [
                // {
                //     "type": "menu",
                //     "title": "Classic Search",
                //     "icon": "search",
                //     "materialicon": "search",
                //     "link": "/search",
                //     "key": "Search",
                //     "style": {
                //         'color': '#61A5DC'
                //     }
                // },
                {
                    "type": "menu",
                    "title": "Search",
                    "icon": "find_in_page",
                    "materialicon": "find_in_page",
                    "link": "/advsearch",
                    "key": "Search",
                    "style": {
                        'color': '#e65100'
                    }
                },
                {
                    "type": "menu",
                    "title": "Process Flows",
                    "icon": "fa fa-cogs",
                    "materialicon": "schema",
                    "link": "/userprocessflows",
                    "key": "userprocessflows",
                    "style": {
                        'color': '#827717'
                    }
                },
                {
                    "type": "menu",
                    "title": "Themes",
                    "icon": "fa fa-cogs",
                    "materialicon": "color_lens",
                    "link": "/themes",
                    "key": "Themes",
                    "style": {
                        'color': '#9500ae'
                    }
                },
                {
                    "type": "menu",
                    "title": "Records",
                    "key": "newapplicationdetails",
                    "link": "#/Records/RECYCLERS",
                    "icon": "fa fa-file-text",
                    "materialicon": "new_releases",
                    "style": {
                        'color': '#9c27b0'
                    }
                },

                {
                    "type": "menu",
                    "title": "Reports",
                    "icon": "fa fa-files-o",
                    "link": getEnvVariable('ReportsUI'),
                    "key": "reports",
                    "newtab": true,
                    "materialicon": "post_add",
                    "style": {
                        'color': '#827717'
                    }
                },
                // {
                //     "type": "menu",
                //     "title": "Applicants",
                //     "icon": "fa fa-building",
                //     "link": "/Administration/companies",
                //     "key": "companies",
                //     "materialicon": "apartment",
                //     "style": {
                //         'color': '#ea156d'
                //     }
                // },
                // {
                //     "type": "menu",
                //     "title": "Consultants",
                //     "icon": "fa fa-building",
                //     "link": "/Administration/consultants",
                //     "key": "consultants",
                //     "materialicon": "connect_without_contact",
                //     "style": {
                //         'color': '#cddc39'
                //     }
                // },
                // {
                //     "type": "menu",
                //     "title": "External Contacts",
                //     "key": "contacts",
                //     "link": "/Administration/globalexternalcontacts",
                //     "icon": "fa fa-user-circle-o",
                //     "materialicon": "contacts",
                //     "style": {
                //         'color': '#006064'
                //     }
                // },


            ],
        "publichublist":
            [

                {
                    "type": "menu",
                    "title": "Companies",
                    "icon": "fa fa-building",
                    "link": "/Administration/companies",
                    "key": "companies",
                    "materialicon": "apartment",
                    "style": {
                        'color': '#ea156d'
                    }
                },
                // {
                //     "type": "menu",
                //     "title": "Consultants",
                //     "icon": "fa fa-building",
                //     "link": "/Administration/consultants",
                //     "key": "consultants",
                //     "materialicon": "connect_without_contact",
                //     "style": {
                //         'color': '#cddc39'
                //     }
                // },
                {
                    "type": "menu",
                    "title": "External Users",
                    "icon": "fa fa-users",
                    "link": "/Administration/externalusers",
                    "key": "ExternalUsers",
                    "materialicon": "person",
                    "style": {
                        'color': '#01579b'
                    }
                },
                // {
                //     "type": "menu",
                //     "title": "Individuals",
                //     "icon": "fa fa-building",
                //     "link": "/Administration/companies",
                //     "key": "companies",
                //     "materialicon": "connect_without_contact",
                //     "style": {
                //         'color': '#cddc39'
                //     }
                // },
                {
                    "type": "menu",
                    "title": "Companies Approval",
                    "key": "registrationrequest",
                    "link": "/Administration/registrationrequest",
                    "icon": "fa fa-caret-square-o-right",
                    "materialicon": "how_to_vote",
                    "style": {
                        'color': '#9fa8da'
                    }
                },
                {
                    "type": "menu",
                    "title": "Company Approval Users",
                    "icon": "assignment_turned_in",
                    "materialicon": "assignment_turned_in",
                    "link": "/Portal/Approvals",
                    "key": "Search",
                    "style": {
                        'color': '#1b5e20'
                    }
                },
                {
                    "type": "menu",
                    "title": "External Contacts",
                    "key": "contacts",
                    "link": "/Administration/globalexternalcontacts",
                    "icon": "fa fa-user-circle-o",
                    "materialicon": "contacts",
                    "style": {
                        'color': '#006064'
                    }
                },

            ],
        "Adminlist":
            [
                {
                    "type": "menu",
                    "title": "Users",
                    "icon": "fa fa-users",
                    "link": "#/Administration/agencyusers",
                    "key": "AgencyUsers",
                    "materialicon": "person",
                    "style": {
                        'color': '#01579b'
                    }
                },
                {
                    "type": "menu",
                    "title": "Roles",
                    "key": "roles",
                    "link": "#/Administration/roles",
                    "icon": "fa fa-user-circle-o",
                    "materialicon": "manage_accounts",
                    "style": {
                        'color': '#004d40'
                    }
                },

                {
                    "type": "menu",
                    "title": "Groups",
                    "key": "groups",
                    "link": "#/Administration/groups",
                    "icon": "fa fa-users",
                    "materialicon": "device_hub",
                    "style": {
                        'color': '#3f51b5'
                    }
                },


                {
                    "type": "menu",
                    "title": "Regions",
                    "key": "regions",
                    "link": "#/Administration/regions",
                    "icon": "fa fa-map",
                    "materialicon": "streetview",
                    "style": {
                        'color': '#61A5DC'
                    }
                },


                {
                    "type": "menu",
                    "title": "Counties",
                    "key": "sites",
                    "link": "#/Administration/counties",
                    "icon": "fa fa-globe",
                    "materialicon": "settings_system_daydream",
                    "style": {
                        'color': '#006064'
                    }
                },
                {
                    "type": "menu",
                    "title": "Email Groups",
                    "key": "groupemails",
                    "link": "#/Administration/groupemails",
                    "icon": "fa fa-domain",
                    "materialicon": "email",
                    "style": {
                        'color': '#0c755b'
                    }
                },
                {
                    "type": "menu",
                    "title": "Switch Workflow",
                    "key": "switchworkflow",
                    "link": "#/Administration/switchworkflow",
                    "icon": "fa fa-domain",
                    "materialicon": "person_add",
                    "style": {
                        'color': '#940786'
                    }
                },


                // {
                //     "type": "menu",
                //     "title": "Registrations",
                //     "key": "registrationrequest",
                //     "link": "#/Administration/registrationrequest",
                //     "icon": "fa fa-caret-square-o-right",
                //     "materialicon": "how_to_vote",
                //     "style": {
                //         'color': '#9fa8da'
                //     }
                // },
                {
                    "type": "menu",
                    "title": "Authorization",
                    "key": "Authorization",
                    "link": "#/Administration/authorizations",
                    "icon": "fa fa-globe",
                    "materialicon": "vpn_key",
                    "isOAuth": true,
                    "style": {
                        'color': '#c158dc'
                    }
                },
            ],
        'settings': [
            {
                "type": "menu",
                "title": "Permit Status",
                "icon": "fa fa-donut",
                "link": "#/Administration/applicationstatus",
                "key": "applicationstatus",
                "materialicon": "rotate_right",
                "style": {
                    'color': '#00796b'
                }
            },
            {
                "type": "menu",
                "title": "Permit Types",
                "key": "sitepermittypes",
                "link": "#/Administration/applicationtypes",
                "icon": "fa fa-address-card-o",
                "materialicon": "language",
                "style": {
                    'color': '#a5d6a7'
                }
            },
            {
                "type": "menu",
                "title": "Attachment Types",
                "key": "attachmenttypes",
                "link": "#/Administration/attachmenttypes",
                "icon": "fa fa-paperclip",
                "materialicon": "attach_file",
                "style": {
                    'color': '#b26a00'
                }
            },
            {
                "type": "menu",
                "title": "Image Types",
                "key": "imagetypes",
                "link": "#/Administration/imagetypes",
                "icon": "fa fa-file-image-o",
                "materialicon": "wallpaper",
                "style": {
                    'color': '#ffb300'
                }
            },
            {
                "type": "menu",
                "title": "Master Templates",
                "key": "notices",
                "link": "#/Administration/masternotices",
                "icon": "fa fa-sticky-note",
                "materialicon": "document_scanner",
                "style": {
                    'color': '#ab003c'
                }
            },
            {
                "type": "menu",
                "title": "Project Downloads",
                "key": "settings",
                "link": "#/Administration/projectdownloads",
                "icon": "fa fa-domain",
                "materialicon": "download",
                "style": {
                    'color': '#3f51b5'
                }
            },
            {
                "type": "menu",
                "title": "Notice Types",
                "key": "notices",
                "link": "#/Administration/noticestypes",
                "icon": "fa fa-sticky-note",
                "materialicon": "article",
                "style": {
                    'color': '#8bc34a'
                }
            },
            {
                "type": "menu",
                "title": "Notification Settings",
                "key": "notificationsettings",
                "link": "#/Administration/notificationsettings",
                "icon": "fa fa-bell-o",
                "materialicon": "notifications_active",
                "style": {
                    'color': '#00bfa5'
                }
            },
            {
                "type": "menu",
                "title": "Domains",
                "key": "domains",
                "link": "#/Administration/domains",
                "icon": "fa fa-domain",
                "materialicon": "domain",
                "style": {
                    'color': '#a98274'
                }
            },
            {
                "type": "menu",
                "title": "Layers",
                "key": "layers",
                "link": "#/Administration/layers",
                "icon": "fa fa-domain",
                "materialicon": "layers",
                "style": {
                    'color': '#c85a54'
                }
            },
            // {
            //     "type": "menu",
            //     "title": "InvoiceCycles",
            //     "key": "invoicecycles",
            //     "link": "#/Administration/invoicecycles",
            //     "icon": "fa fa-users",
            //     "materialicon": "paid",
            //     "style": {
            //         'color': '#3f51b5'
            //     }
            // },
        ],
        'sitesettings': [
            {
                "type": "menu",
                "title": "Process Builder",
                "key": "sections",
                "link": "/processflows",
                "icon": "fa fa-columns",
                "materialicon": "developer_board",
                "style": {
                    'color': '#00c853'
                }
            },
            {
                "type": "menu",
                "title": "Form Builder",
                "key": "masterFieldsList",
                "link": "/flows",
                "icon": "fa fa-list-alt",
                "materialicon": "schema",
                "style": {
                    'color': '#e65100'
                }
            },
            {
                "type": "menu",
                "title": "Dashboard Builder",
                "key": "masterpermittypes",
                "link": "/Dashboardflows",
                "icon": "fa fa-id-badge",
                "materialicon": "dashboard",
                "style": {
                    'color': '#795548'
                }
            },

            {
                "type": "menu",
                "title": "Component Builder",
                "key": "settings",
                "link": "/widgets",
                "icon": "fa fa-domain",
                "materialicon": "integration_instructions",
                "style": {
                    'color': '#5ddef4'
                }
            },
            {
                "type": "menu",
                "title": "Report Builder",
                "key": "reportsadmin",
                "link": "/reports",
                "icon": "fa fa-bar-chart",
                "materialicon": "assessment",
                "style": {
                    'color': '#22C55E'
                    }
            },
            // {
            //     "type": "menu",
            //     "title": "Sidebar Rules",
            //     "key": "settings",
            //     "link": "/Administration/sidebarbr",
            //     "icon": "fa fa-domain",
            //     "materialicon": "ballot",
            //     "style": {
            //         'color': '#aeea00'
            //     }
            // },


        ]
    },
}